export const wsErrorHandler = (message: string, err: Error |any) => {
    console.error(`WEBSOCKET: ${message}: `, err);
    console.log(err.cause)
    console.log(err.stack)
    console.log(err.name)
    console.log(err.meesage)
}